import UIFetchService from '../src/Service/UIFetchService';
import AuthFetchService from '../src/Service/AuthFetchService';
import React from 'react';
import { Row, Col, Table,Card, Space,Carousel,video } from 'antd';
import {formatSpaceSize} from '../src/Service/Utils';

const formUrlMap = {
    "百词斩核心报表":"/forms/bcz_core",
    "薄荷芝士派公众号&app用户（流量）":"/forms/mintpie_wx_app",
    "通用核心报表":"/forms/universal_core",
    "未来技能核心报表":"/forms/future_core",
    "大学数学核心报表":"/forms/college_math_core",
    "实时大盘":"/forms/group_realtime",
    "集团日报":"/forms/group_daily",
    "集团周报":"/forms/group_weekly",
    "集团月报":"/forms/group_monthly",
    "集团年报":"/forms/group_year",
    "导流全景":"/forms/full_referral",
    "百词斩导流":"/forms/bcz_referral",
    "薄芝导流":"/forms/mintpie_referral",
    "电商私域导流":"/forms/ec_referral",
    "广告追踪查询":"/forms/ad_tracing",
    "导流UE":"/forms/new_user_referral_30d",
    "平台监控":"/forms/datap_access",
    "BI工具使用监控":"/forms/bi_access",
    "实体商品-履约信息":"/forms/trade",
    "KOL投放监控":"/forms/kol_monitor",
    "订单查询":"/forms/order_query",
    "活动数据":"/forms/activity_data",
    "实时库存监控":"/forms/rt_storage_all",
    "实时库存_薄芝":"/forms/rt_storage_mintpie",
    "实时库存_百词斩":"/forms/rt_storage_bcz",
    "内控在课无订单监控":"/forms/no_order_monitor",
    "百词斩市场舆情":"/forms/bcz_yuqing",
    "薄芝市场舆情":"/forms/mintpie_yuqing",
    "未来技能市场舆情":"/forms/future_yuqing",
    "广告推荐效果监控":"/forms/ad_recommend_monitor",
    "百词斩核心报表_用户留存":"/forms/bcz_retention",
    "公司层人力用工看板_人数":"/forms/hr_group",
    "公司层人力用工看板_成本":"/forms/hr_group_cost",
    "百词斩APP用工看板":"/forms/hr_bcz",
    "成人英语SKU研发用工看板":"/forms/hr_adult_eng_sku",
    "未来技能SKU研发用工看板":"/forms/hr_future_sku",
    "出国市运销用工看板":"/forms/hr_mintpie",
    "大营收多SKU市运销用工看板":"/forms/hr_future_syx",
    "业务平台用工看板":"/forms/hr_abp_middle",
    "技术中台用工看板":"/forms/hr_tech_middle",
    "数据中台用工看板":"/forms/hr_data_middle",
    "战略中台用工看板":"/forms/hr_strategy_middle",
    "履约供应链中台用工看板":"/forms/hr_chain_middle",
    "人力用工看板":"/forms/hr_hr",
    "财务用工看板":"/forms/hr_finance",
    "法务合规用工看板":"/forms/hr_legal",
    "行政用工看板":"/forms/hr_administration",
    "产品导向SKU研发用工看板":"/forms/hr_poc",
    "薄芝_核心经营":"/forms/mintpie_analyse_sale",
    "薄芝_自有流量":"/forms/mintpie_analyse_self_flow",
    "薄芝_2022活动监控":"/forms/mintpie_analyse_activity_2022",
    "薄芝_新概念":"/forms/mintpie_analyse_nce",
    "薄芝_托福":"/forms/mintpie_analyse_toefl",
    "SKU用户满意度":"/forms/sku_satisfaction",
    "积分看板":"/forms/credit_data",
    "薄芝_番茄":"/forms/mintpie_analyse_tomato",
    "课程质量评估监控":"/forms/course_quality",
    "大学及成人英语":"/forms/adult_english",
    "百词斩用户画像":"/forms/bcz_user_profile",
    "提分宝核心报表":"/forms/tifenbao",
    "出国_雅思":"/forms/abroad_ielts",
    "单词机核心报表":"/forms/hardware_word_machine",
    "硬件总览看板":"/forms/hardware_overall",
    "监控预警":"/forms/general_monitor",
    "大营收多SKU总览":"/forms/fc_overview",
    "K12核心报表":"/forms/k12_core",
    "出国核心报表":"/forms/abroad_core",
    "蛋糕核心报表":"/forms/k12_cake",
    "词典笔核心报表":"/forms/hardware_dictionary_pen",
    "扫学机核心报表":"/forms/hardware_learn_machine",
    "出国销售用工看板":"/forms/hr_sales_abroad",
    "大营收销售用工看板":"/forms/hr_sales_fc",
    "新阅读核心看板":"/forms/newreading_core",
    "彩屏单词机核心看板":"/forms/hardware_color_machine"
}
function getYesterday(){
    var date1 = new Date();
    date1.setTime(date1.getTime() - 24*60*60*1000);
    return date1.getFullYear() + '年' + String(date1.getMonth() + 1).padStart(2,'0') + '月' + String(date1.getDate()).padStart(2,'0') + '日'
}
class IndexView extends React.Component {
    constructor() {
        super();
        this.state = {
            topFormsAllUser:[],
            topFormsCurrentUser:[],
            topUsers:[],
            totalOdpsTableCnt:0,
            totalOdpsTableSize:0.00,
            yeaterday: ''
        };
    }

    componentDidMount() {
        this.fetchTopInfo();
        AuthFetchService.appendLog('首页');
    }

    async fetchTopInfo(){
        const topFormsCUser = await UIFetchService.get('/api/v1/user/stat/get_top_forms_by_user');
        for (let i = 0; i < topFormsCUser.data.length; i++) {
            const form = {
                index: 'No.' + (i+1),
                formName: topFormsCUser.data[i],
                formUrl: formUrlMap[topFormsCUser.data[i]]
            };
            this.setState({topFormsCurrentUser:[...this.state.topFormsCurrentUser, form]})
        }

        const topFormsAllUser = await UIFetchService.get('/api/v1/user/stat/get_top_forms_all_user');
        for (let i = 0; i < topFormsAllUser.data.length; i++) {
            const form = {
                index: 'No.' + (i+1),
                formName: topFormsAllUser.data[i],
                formUrl: formUrlMap[topFormsAllUser.data[i]]
            };
            this.setState({topFormsAllUser:[...this.state.topFormsAllUser, form]})
        }

        const topUsers = await UIFetchService.get('/api/v1/user/stat/get_top_users');
        for (let i = 0; i < topUsers.data.length; i++) {
            const user = {
                index: 'No.' + (i+1),
                userName: topUsers.data[i]
            };
            this.setState({topUsers:[...this.state.topUsers, user]})
        }

        const odpsStat = await UIFetchService.get('/api/v1/metadata/stat/get_all_statistics');
        this.setState({totalOdpsTableCnt: odpsStat.data.numberOfTables, totalOdpsTableSize: odpsStat.data.sizeInBytes})
    }

    render() {
        const textStyle = {
            fontSize: '14px',
            fontWeight: 400,
            color: '#66686B',
            lineHeight: '22px',
            margin: '0px 10px 0px 10px'
        };

        const titleStyle = {
            fontSize: '16px',
            fontWeight: '500',
            color: '#3C3D3F',
            lineHeight: '24px',
            margin: '20px 10px 10px 10px'
        };

        const titleStyle1 = {
            fontSize: '16px',
            fontWeight: '500',
            color: '#3C3D3F',
            lineHeight: '24px',
            margin: '20px 10px'
        };

        const iconStyle = {
            margin: '10px'
        };

        return <>
            <Row style={{ padding: '20px 0px 0px 0px' }} justify="start">
                <Col offset={3} span={18}>
                    <div style={{position:'absolute',margin:'140px 50px',justifyContent:'center'}}>
                        <h1 style={{fontSize:'36px'}}>数智未来</h1>
                        <div style={{fontSize:'16px'}}>数据驱动决策，共创美好未来</div>
                    </div>
                    <video src="/head-banner.mp4" autoPlay loop width="100%" height="100%">
                    </video>
                </Col>
            </Row>
            <div style={{ height: 10 }} ></div>
            <Row>
                <Col offset ={3} span={18}>
                <Card style={{ borderRadius: 0 }} bodyStyle={{marginTop:'-10px',marginBottom:'-20px',marginLeft:'-20px'}}>
                    <div>
                        <span style={titleStyle}>集团数据资产概览</span>
                        <span style={textStyle}>(数据统计截止{getYesterday()})</span>
                    </div>
                    <Row>
                    <Col span={8} offset={3}>
                        <Row>
                            <Col>
                                <img
                                    alt="icon"
                                    width="50"
                                    height="50"
                                    src="/table-icon.png"
                                    style={{margin: '20px 0px 10px 40px'}}
                                ></img>
                            </Col>
                            <Col>
                                <p style={titleStyle}>总表数：{this.state.totalOdpsTableCnt}张</p>
                                <p style={textStyle}>集团数据仓库所有表数量</p>
                            </Col>
                        </Row>
                    </Col>
                    <Col span={8} offset={2}>
                        <Row>
                            <Col>
                                <img
                                    alt="icon"
                                    width="60"
                                    height="60"
                                    src="/storage-icon.png"
                                    style={{margin: '20px 0px 10px 0px'}}
                                ></img>
                            </Col>
                            <Col>
                                <p style={titleStyle}>数据存储总量：{formatSpaceSize(this.state.totalOdpsTableSize)}</p>
                                <p style={textStyle}>集团数据仓库所有表占用存储空间</p>
                            </Col>
                        </Row>
                    </Col>
                    </Row>
                    </Card>
                </Col>
            </Row>

            <div style={{ height: 10 }} ></div>
            <Row>
                <Col span={6} offset={3}>
                    <Row>
                        <Col offset={2}>
                            <img alt="icon" style={iconStyle} width="40" height="40" src="/my-forms-icon.png"></img>
                        </Col>
                        <Col>
                            <p style={titleStyle1}>我的常用看板</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={20}>
                            <Table 
                                dataSource={this.state.topFormsCurrentUser} 
                                showHeader={false} 
                                pagination={false} 
                                size='small'
                                rowClassName={(record, index) => index % 2 === 0 ? 'site-item-grid' : ''}>
                                <Table.Column
                                    title=""
                                    dataIndex="index"
                                    key="index"
                                    width={30}
                                />
                                <Table.Column
                                    title=""
                                    dataIndex="formName"
                                    key="formName"
                                    width={200}
                                    render={(value, record) =>
                                        <a href={record.formUrl}>{value}</a>}
                                />
                            </Table>
                        </Col>
                    </Row>
                </Col>
                <Col span={6}>
                    <Row>
                        <Col offset={4}>
                            <img alt="icon" style={iconStyle} width="40" height="40" src="/most-form-icon.png"></img>
                        </Col>
                        <Col>
                            <p style={titleStyle1}>最受欢迎看板TOP5</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={20} offset={2}>
                            <Table 
                                dataSource={this.state.topFormsAllUser} 
                                showHeader={false} 
                                pagination={false} 
                                size='small'
                                rowClassName={(record, index) => index % 2 === 0 ? 'site-item-grid' : ''}>
                                <Table.Column
                                    title=""
                                    dataIndex="index"
                                    key="index"
                                    width={30}
                                />
                                <Table.Column
                                    title=""
                                    dataIndex="formName"
                                    key="formName"
                                    width={200}
                                    render={(value, record) =>
                                        <a href={record.formUrl}>{value}</a>}
                                />
                            </Table>
                        </Col>
                    </Row>
                </Col>
                <Col span={6}>
                    <Row>
                        <Col offset={6}>
                            <img alt="icon" style={iconStyle} width="40" height="40" src="/most-user-icon.png"></img>
                        </Col>
                        <Col>
                            <p style={titleStyle1}>最爱看数用户TOP5</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={20} offset={4}>
                            <Table 
                                dataSource={this.state.topUsers} 
                                showHeader={false} 
                                pagination={false} 
                                size='small'
                                rowClassName={(record, index) => index % 2 === 0 ? 'site-item-grid' : ''}>
                                <Table.Column
                                    title=""
                                    dataIndex="index"
                                    key="index"
                                    width={30}
                                />
                                <Table.Column
                                    title=""
                                    dataIndex="userName"
                                    key="userName"
                                    width={200}
                                />
                            </Table>
                        </Col>
                    </Row>
                </Col>
            </Row>
            <div style={{ height: 20 }} ></div>
            <Row>
                <Col span={18} offset={3}>
                    <Card style={{ borderRadius: 0 }} bodyStyle={{marginTop:'-30px', marginBottom:'-15px'}}>
                        <Row>
                            <Col>
                                <p style={titleStyle}>推荐阅读</p>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Space direction='horizontal'>
                                    <a href="https://shimo.im/docs/gO3oxbDM4QtrYGqD" target="_blank" rel="noreferrer">《数据中台-帮助文档》</a>
                                    <a href="https://shimo.im/docs/473QyGPVOXumdN3w" target="_blank" rel="noreferrer">《数据中台-数据工具最佳实践》</a>
                                    <a href="https://shimo.im/docs/1d3aV40YLQSYdnqg" target="_blank" rel="noreferrer">《统一埋点流程&规范》</a> 
                                    <a href="https://shimo.im/docs/5rk9d7W1G4I2PVqx" target="_blank" rel="noreferrer">《超有爱PII数据安全规范&导数流程手册》</a>
                                </Space>
                            </Col>
                        </Row>
                    </Card>
                </Col>
            </Row>
        </>;
    }
}

export default IndexView;